import { render, staticRenderFns } from "./BestaetigungView.vue?vue&type=template&id=5e16188e"
import script from "./BestaetigungView.vue?vue&type=script&lang=js"
export * from "./BestaetigungView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports